import {
  useGetAdminConnectivitySftp,
  usePostAdminConnectivitySftp
} from '@ijoin/hooks';
import { createFileRoute } from '@tanstack/react-router';

import { ConnectivityChecks } from '../../components';

const SftpConnectivityPage = () => (
  <ConnectivityChecks
    label='SFTP'
    linkIntegration={false}
    queryKey='/api/v3/admin/connectivity/sftp'
    showHost
    showOrganizations={false}
    testId='sftpConnectivity'
    useQuery={useGetAdminConnectivitySftp}
    useRefresh={usePostAdminConnectivitySftp}
  />
);

export const Route = createFileRoute('/connectivity/sftp')({
  component: SftpConnectivityPage
});
